import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropertyCard from "./PropertyCard";
import "./TopPropertyStyles/TopProperties.css";
import api from "../../../api/axios.js";
import Loading from "../../Loading/Loading.jsx";

const TopProperties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(4);

  // Fetch Data from API
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await api.get("/api/get-properties");
        const result = response.data;

        if (result && result.data) {
          setProperties(result.data);
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  if (loading) {
    return <Loading></Loading>;
  }

  return (
    <section className="properties-section" id="available-properties">
      <div className="container">
        <div className="section-header">
          <h2>
            AVAILABLE <span className="section-header-title">PROPERTIES</span>
          </h2>
          <p>Browse through our diverse portfolio of properties</p>
        </div>

        <div className="properties-grid">
          {properties.slice(0, visibleCount).map((property) => (
            <div key={property.id} className="grid-item">
              <PropertyCard property={property} />
            </div>
          ))}
        </div>

        <div
          className="see-more-container"
          style={{ textAlign: "center", marginTop: "40px" }}
        >
          <Link to="/greenland/properties" className="see-all-btn">
            See All Properties
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TopProperties;
